import Ws from "../../providers/Ws";
import Utils from "../../providers/Utils";

export default class FromServer {


    getUsersAll = async () => {

        let ws = new Ws();


        let users = await ws.customSelect(`select u.id ,
            a.nume, a.poza, u.email from  useri u 
            left join angajati a on u.id = a.id_user
            where isnull(u.inactiv,0) != @p1 `, {
                p1: 1
            })

        if (users.Succes) {
            return users.Content
        }
    }

    getProiecte = async (idUser) => {
        let ws = new Ws()

        let proiecte = await ws.customSelect(`select * from proiecte where id in
            (select id_proiect from proiecte_drepturi where id_utilizator =  @p1) and isnull(sters,0) != 1`, {
                p1: idUser
            })

        if (proiecte.Succes) {
            return proiecte
        }
    }

    getUser = async (id) => {

        let ws = new Ws();


        let users = await ws.customSelect(`select u.id, u.nume, a.poza , u.email, u.telefon,
                                                u.access_proiecte, u.creaza_proiecte, 
                                                u.is_admin, u.modifica_angajati from useri u 
            left outer join angajati a on (a.id_user = u.id) where u.id = @p1 `, {
                p1: id
            })

        if (users.Succes) {
            return users.Content
        }
    }

    getDetaliiUser = async (id) => {

        let ws = new Ws()

        let user = await ws.customSelect(`select u.id, a.nume, a.poza , u.email, u.telefon from angajati a 
        left outer join useri u on (a.id_user = u.id) where u.id = @p1 `, {
                p1:id
            })

            if(user.Succes){
                return {r:true, m:user.Messsage, c:user.Content }
            }else{
                return {r:false, m:user.Messsage, c:null}
            }
            
    }

    updateUser = async (obj, id) => {
        let ws = new Ws();


        let users = await ws.update("useri", obj, { id: id })

        if (users.Succes) {
            return true
        }
    }

    insertUser = async (obj) => {
        let ws = new Ws();


        let insertU = await ws.insert('useri', obj)

        let objToInsert = { ok: false, content: [] }

        // console.log('insertU :', insertU);

        if (insertU.Succes) {
            objToInsert.ok = true
            objToInsert.content = insertU.Content

            return objToInsert
        }
    }

    getInfoProiect = async (id) => {


        let ws = new Ws();


        let getInfoProiect = await ws.customSelect(`select * from proiecte where id = @p1`, {
            p1: id
        })

        if (getInfoProiect.Succes) {
            return getInfoProiect.Content
        }
    }

    getEtapeAll = async () => {
        let ws = new Ws();

        let u = new Utils();

        let etape = await ws.customSelect('select id, id_proiect, note, durata_de_la, durata_pana_la, id_user_responsabil, denumire, statusul from proiecte_etape where  isnull(inactiv,0) !=@p1 and id_proiect in (select id from proiecte where isnull(sters,0) != 1) order by durata_pana_la asc ', {
            p1: 1
        })

        // console.log('etape :', etape);
        if (etape.Succes) {

            let cloneEtape = [...etape.Content]

            let counter = cloneEtape.length

            for (let i = 0; i < counter; i++) {
                cloneEtape[i].durata_de_la = u.ParseDataFromSql(cloneEtape[i].durata_de_la)
                cloneEtape[i].durata_pana_la = u.ParseDataFromSql(cloneEtape[i].durata_pana_la)
            }
            return etape.Content
        }
    }


    getTaskuriAll = async (idUtilizator) => {
        let ws = new Ws();

        let u = new Utils();

        let taskuri = await ws.customSelect(`select t.*, u.* from taskuri t
                                             left outer join
                                              useri u on (t.id_utilizator_responsabil = u.id) 
                                              where t.id_etapa_proiect in 
                                              (select id from proiecte_etape where isnull(inactiv, 0) != 1) 
                                              and isnull(t.inactiv,0) !=1 and t.id_utilizator_responsabil = @p1 order by t.cand_data asc`, {
                p1: idUtilizator
            })

        // console.log('taskuri :', taskuri);
        if (taskuri.Succes) {

            let cloneTaskuri = [...taskuri.Content]

            let counter = cloneTaskuri.length

            for (let i = 0; i < counter; i++) {
                cloneTaskuri[i].durata_de_la = u.ParseDataFromSql(cloneTaskuri[i].durata_de_la)
                cloneTaskuri[i].durata_pana_la = u.ParseDataFromSql(cloneTaskuri[i].durata_pana_la)
            }
            return taskuri.Content
        }
    }

    getEtape = async (id) => {
        let ws = new Ws();

        let u = new Utils();

        //  'select id, id_proiect, note, durata_de_la, durata_pana_la, id_user_responsabil, denumire, statusul from proiecte_etape where id_proiect = @p1 and isnull(inactiv,0) !=1 '

        let etape = await ws.customSelect(
            `select e.*, u.email,u.telefon, a.* from  proiecte_etape e left outer join useri u 
            on (e.id_user_responsabil = u.id)
            left outer join angajati a on(u.id = a.id_user)
             where e.id_proiect = @p1 and  isnull(e.inactiv,0) !=1 `

            , {
                p1: id
            })

        // console.log('etape :', etape);
        if (etape.Succes) {

            let cloneEtape = [...etape.Content]

            let counter = cloneEtape.length

            for (let i = 0; i < counter; i++) {
                cloneEtape[i].durata_de_la = u.ParseDataFromSql(cloneEtape[i].durata_de_la)
                cloneEtape[i].durata_pana_la = u.ParseDataFromSql(cloneEtape[i].durata_pana_la)
            }
            return etape.Content
        }
    }

    getTaskuri = async (id, idU) => {
        let ws = new Ws();

        let u = new Utils();

        let taskuri = await ws.customSelect(`select t.*, u.email,u.telefon, a.* from taskuri t left outer join useri u 
                                                    on (t.id_utilizator_responsabil = u.id)
                                                    left outer join angajati a on(u.id = a.id_user)
                                                     where t.id_proiect = @p1 and t.id_etapa_proiect in 
                                                     (select id from proiecte_etape where id_proiect = @p1 and isnull(inactiv, 0) != 1) and isnull(t.id_task_parent, 0) = 0
                                                      and  isnull(t.inactiv,0) !=1 and t.id_utilizator_responsabil = @p2 order by t.cand_data asc`, {
                p1: id,
                p2: idU
            })

        // console.log('taskuri :', taskuri);
        if (taskuri.Succes) {

            let cloneTaskuri = [...taskuri.Content]

            let counter = cloneTaskuri.length

            for (let i = 0; i < counter; i++) {
                cloneTaskuri[i].durata_de_la = u.ParseDataFromSql(cloneTaskuri[i].durata_de_la)
                cloneTaskuri[i].durata_pana_la = u.ParseDataFromSql(cloneTaskuri[i].durata_pana_la)
            }
            return taskuri.Content
        }
    }

    getSubTaskuri = async (id, idU) => {
        let ws = new Ws();

        let u = new Utils();

        let taskuri = await ws.customSelect(`select t.*, u.email,u.telefon, a.* from taskuri t left outer join useri u 
                                            on (t.id_utilizator_responsabil = u.id)
                                            left outer join angajati a on(u.id = a.id_user)
                                            where t.id_proiect = @p1 and t.id_etapa_proiect in 
                                            (select id from proiecte_etape where id_proiect = @p1 and isnull(inactiv, 0) != 1) and isnull(t.id_task_parent, 0) != 0
                                                and  isnull(t.inactiv,0) !=1 and t.id_utilizator_responsabil = @p2 order by t.cand_data asc`, {
                p1: id,
                p2: idU
            })

        // console.log('taskuri :', taskuri);
        if (taskuri.Succes) {

            let cloneTaskuri = [...taskuri.Content]

            let counter = cloneTaskuri.length

            for (let i = 0; i < counter; i++) {
                cloneTaskuri[i].durata_de_la = u.ParseDataFromSql(cloneTaskuri[i].durata_de_la)
                cloneTaskuri[i].durata_pana_la = u.ParseDataFromSql(cloneTaskuri[i].durata_pana_la)
            }
            return taskuri.Content
        }
    }

    getTaskuriTimpiLucru = async(idUser, idTask) =>{
        let ws = new Ws();


        let getTimpiLucru = await ws.customSelect('select * from taskuri_timpi_lucru where id_user = @p1 and id_task = @p2 and isnull(sters,0) !=1',{
            p1:idUser,
            p2:idTask
        })

        if(getTimpiLucru.Succes){
            return getTimpiLucru
        }
    }

    updateTask = async (obj, id) => {
        let ws = new Ws();

        let update = await ws.update('taskuri', obj, { id: id })

        // console.log('update :', update);

        if (update.Succes) {
            return true
        }
    }

    updateEtapa = async (obj, id) => {
        let ws = new Ws();

        let update = await ws.update('proiecte_etape', obj, { id: id })

        // console.log('update :', update);

        if (update.Succes) {
            return true
        }
    }

    getUsers = async (idProiect = null) => {
        let ws = new Ws();

        let getUsers = await ws.customSelect(`select d.doar_citire, d.nivel_responsabil, d.drepturi_extinse, d.id_utilizator as id ,
                                             a.nume, a.poza, u.email from proiecte_drepturi d left join useri u on d.id_utilizator = u.id
                                             left join angajati a on u.id = a.id_user
                                             where d.id_proiect = @p1 and isnull(u.inactiv,0) != 1 order by isnull(d.nivel_responsabil,3) asc`, {
                p1: idProiect
            })

        // console.log('getUSers :', getUsers);
        if (getUsers.Succes) {
            return getUsers.Content
        }
    }



}